import { RumEvent } from '@datadog/browser-rum';

// Angular HttpClient reports a request that never reached the server (offline,
// navigation away mid-flight, DNS/TLS abort, timeout) as an HttpErrorResponse with
// status 0 / "Unknown Error". These are handled and logged to console.error
// (directly or via the @ngrx/data effect), so DD RUM captures them as source:console
// errors even though they are client-side transport noise, not an app defect or a
// backend 5xx - backend availability is covered server-side. Match the canonical
// Angular status-0 message so real errors are left untouched.
export const isTransportAbortError = (event: RumEvent): boolean =>
    event.type === 'error' &&
    event.error.source === 'console' &&
    (event.error.message?.includes(': 0 Unknown Error') ?? false);
